<template>
  <div class="floor-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <p class="flex align-center">小区名称：<el-input :value="communityName" readonly class="flex-sub"></el-input></p>
        <el-button type="primary" @click="addFloor('','')">新增楼栋</el-button>
      </div>
      <div class="padding-tb">
        <div class="floor-list flex align-start flex-wrap">
          <div class="floor-item" v-for="item in floorList" :key="item.id">
            <p>{{item.building_name}}</p>
            <div class="flex align-center justify-around">
              <el-button type="text" @click="setFloor(item.building_name,item.id)">设置</el-button>
              <el-button type="text" @click="addFloor(item.building_name,item.id)">修改</el-button>
              <el-button type="text" @click="delFloor(item.id)">删除</el-button>
            </div>
          </div>
        </div>


        <div class="no-data" v-if="noData">
          <img src="../../assets/img/no-data.png" alt="">
          <p>您还未创建楼栋信息，赶快创建吧！</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {louAdd, louDel, louList} from "@/api/community";

export default {
  name: "floor-management",
  data() {
    return {
      projectId: '',
      communityId: '',
      communityName: '',
      floorList: [],
      noData: false
    }
  },
  created() {
    this.$emit("setIndex", '/home/community', "系统管理 / 小区管理 / 楼宇管理", true);
    this.projectId = this.$route.params.pid
    this.communityId = this.$route.params.cid
    this.communityName = this.$route.query.name
    this.louList()
  },
  components: {},
  methods: {
    //  楼宇设置
    setFloor(name,fid){
      this.$router.push({
        path: `/home/unit-management/${fid}/${this.communityId}/${this.projectId}`,
        query:{
          name:name
        }
      })
    },
    //  添加楼栋
    addFloor(val,fid){
      this.$prompt('楼栋名称：', '新增楼栋', {
        inputValue:val,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        if(!value) return
        this.sureAddFloor(value,fid)
      })
    },
    async sureAddFloor(value,fid){
      let _state = await louAdd(this.communityId, this.projectId,value,fid)
      this.$message.success(_state.info)
      this.louList()
    },
    delFloor(fid){
      this.$confirm('您确定要删除吗？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.sureDelFloor(fid)
      })
    },
    async sureDelFloor(fid){
      let _state = await louDel(fid)
      this.$message.success(_state.info)
      this.louList()
    },






    //  楼栋列表
    async louList() {
      let _list = await louList(this.communityId, this.projectId)
      this.floorList = _list.data
      this.floorList.length > 0 ? this.noData = false : this.noData = true
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.floor-warpper{
  .floor-list{
    .floor-item{
      width: 150px;
      min-height: 80px;
      padding: 20px;
      margin: 0 30px 30px 0;
      border: 1px solid #d00000;
      p{
        font-size: 16px;
        text-align: center;
        margin-bottom: 10px;
      }
      .el-button{
        padding: 0;
      }
    }
  }
  .no-data{
    img{
      display: block;
      margin: 30px auto;
    }
    p{
      text-align: center;
    }
  }
}

</style>
